// extracted by mini-css-extract-plugin
module.exports = {"new-table":"FinalReportVariantsTable_new-table__2tO0u"};